import { Button } from "../ui/button";
import { Card } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Plus, Trash } from "@phosphor-icons/react";

const MissionList = ({ items, onChange }) => {
  const set = (i, k, v) => onChange(items.map((m, j) => (j === i ? { ...m, [k]: v } : m)));
  return (
    <div>
      <Label>Mission points</Label>
      <div className="space-y-2 mt-1">
        {items.map((m, i) => (
          <div key={i} className="grid md:grid-cols-[220px_1fr_auto] gap-2" data-testid={`settings-mission-${i}`}>
            <Input value={m.title} placeholder="Title" onChange={(e) => set(i, "title", e.target.value)} data-testid={`settings-mission-${i}-title`} />
            <Input value={m.text} placeholder="Description" onChange={(e) => set(i, "text", e.target.value)} data-testid={`settings-mission-${i}-text`} />
            <Button type="button" variant="outline" onClick={() => onChange(items.filter((_, j) => j !== i))} data-testid={`settings-mission-${i}-remove`}><Trash size={16} /></Button>
          </div>
        ))}
      </div>
      <Button type="button" variant="outline" size="sm" className="mt-2" disabled={items.length >= 12}
        onClick={() => onChange([...items, { title: "", text: "" }])} data-testid="settings-mission-add">
        <Plus size={14} className="mr-1" /> Add point
      </Button>
    </div>
  );
};

export const AboutExtraFields = ({ value, onChange }) => {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <Card className="p-5 border-zinc-200 space-y-4">
      <div><Label>Our Vision</Label>
        <Textarea rows={2} value={value.vision} onChange={(e) => set("vision", e.target.value)} className="mt-1" data-testid="settings-vision" /></div>
      <MissionList items={value.mission} onChange={(v) => set("mission", v)} />
      <div><Label>Our Commitment to Every Child</Label>
        <Textarea rows={3} value={value.commitment} onChange={(e) => set("commitment", e.target.value)} className="mt-1" data-testid="settings-commitment" /></div>
      <div><Label>Our Motto</Label>
        <Input value={value.motto} onChange={(e) => set("motto", e.target.value)} className="mt-1" data-testid="settings-motto" /></div>
      <div><Label>Message from the Correspondent</Label>
        <Textarea rows={10} value={value.correspondent_message} onChange={(e) => set("correspondent_message", e.target.value)} className="mt-1" data-testid="settings-correspondent-message" />
        <p className="text-xs text-zinc-500 mt-1">Signed &quot;With best wishes, Correspondent&quot; with both school names. Leave empty to hide this block.</p></div>
      <div><Label>Correspondent&apos;s quote</Label>
        <Input value={value.correspondent_quote} onChange={(e) => set("correspondent_quote", e.target.value)} className="mt-1" data-testid="settings-correspondent-quote" /></div>
    </Card>
  );
};
